<template>
  <router-view />
</template>

<script></script>

<style>
@import '~bootstrap/dist/css/bootstrap.css';
</style>
